import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cwhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
        
         <Sides/>
       <Helmet>
 
 <title>while loop Statement in c++ tutorial For Beginners</title>
 <meta name="description" content="while loop in c++ tutorial for beginners.while loop in cpp is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,while loop in c++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,while loop in cpp,c++ programming tutorial for beginners,cpp while,c++ while loop,cpp while do,while statement in cpp,while loop c++ programming,while scanf,while c++ programming,while loop syntax in c++,nested while loop in cpp,while loop example in cpp,while loop in c++ programming example ppt,while loop in c++ language" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-while" />
 </Helmet>
 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">While loop Statement in c++</h1>
    <div className="first">
        <a href="/cpp-looping"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-do-while"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">While loop c++:</h2>
    <p className="mt-4 para">While the loop will give this condition. And the loop's body executes until the given condition is false.</p>
   



<h2 className='headings'>While loop C++ syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            
          <span className="qwerty-5">While </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">condition</span>
            <span className ="qwerty-3">)</span>
          
   
           
           
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">Statement </span>
         
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#123; </span>

            {"\n"}{"\n"}{"    "}
            <span className="qwerty-10">body</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Q-Write a program to Increment value in C++ while loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">1 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-4">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">++;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">OR</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3"> +</span>
            <span className="qwerty-10"> 1</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"} 
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>





<h2 className='headings'>Q-Write a program decrement or Subtract in while loop in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "} 
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-4">cout</span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">--;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">OR</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3"> -</span>
            <span className="qwerty-10"> 1</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>






<h2 className='headings'>While loop uses logic operator C++ Example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">&&</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">||</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">While loop Reverse C++</h2>


<h2 className='headings'>Q-Write a program to input an integer number and print in reverse in C++ programming?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int</span>
            <span className="qwerty-10"> n</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a no</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-10"> n</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-6">while </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">n </span>
            <span className="qwerty-5">&#62; </span>
            <span className="qwerty-10">0</span>
            <span className="qwerty-3"> )</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">n </span>
            <span className="qwerty-3">% </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-10">n </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">n </span>
            <span className="qwerty-3">/ </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-5">enter a no </span>
              <span className="qwerty-10">2468 </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">8642 </span>
              {"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to input found out the sum of digits of integer no?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-4">int</span>
            <span className="qwerty-10"> n</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10"> enter a no</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-10"> n</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> n </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10"> 0</span>
            <span className="qwerty-3"> )</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">n </span>
            <span className="qwerty-3">% </span>
            <span className="qwerty-10"> 10</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">sum </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">sum</span>
            <span className="qwerty-3"> +</span>
            <span className="qwerty-5"> n </span>
            <span className="qwerty-3">% </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">n</span>
            <span className="qwerty-3"> = &#60;&#60; </span>
            <span className="qwerty-10">n </span>
            <span className="qwerty-3">/</span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60;" </span>
            <span className="qwerty-10">Sum  </span>
            <span className="qwerty-3">of </span>
            <span className="qwerty-5">Digits </span>
            <span className="qwerty-3">="&#60;&#60;</span>
            <span className="qwerty-10"> sum </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-5">enter a no </span>
              <span className="qwerty-10">2468 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">sum </span>
              <span className="qwerty-10">of </span>
              <span className="qwerty-5">digit</span>
              <span className="qwerty-3">=</span>
              <span className="qwerty-10"> 20</span>
              {"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Cwhile;